import { render, staticRenderFns } from "./modal_add_user.vue?vue&type=template&id=b9610730&scoped=true"
import script from "./modal_add_user.vue?vue&type=script&lang=js"
export * from "./modal_add_user.vue?vue&type=script&lang=js"
import style0 from "./modal_add_user.vue?vue&type=style&index=0&id=b9610730&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9610730",
  null
  
)

export default component.exports